import React from "react";
import estilo from "../styles/Pie.module.css";

function Pie() {
  return (
    <div className={estilo.pie}>
      <p>
        Todos los derechos reservados a <b>RepelisPlus</b>
      </p>
    </div>
  );
}

export default Pie;
